module.exports = __webpack_public_path__ + "img/image.4657bf69.svg";